import React from 'react';
import { Clock } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-navy text-white py-16 px-4" data-id="element-216">
      <div className="max-w-3xl mx-auto text-center" data-id="element-217">
        <div className="inline-flex items-center justify-center gap-2 bg-navy-light px-4 py-2 rounded-full mb-6 border border-blue-800" data-id="element-218">
          <Clock className="text-gold" size={20} data-id="element-219" />
          <span className="font-bold tracking-wide text-sm uppercase" data-id="element-220">
            What changes in 7 days
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-8 leading-tight" data-id="element-221">
          Stop Feeling Like A Spectator In The Decline Of Your Country
        </h2>

        <div className="bg-gradient-to-br from-navy-light to-navy border border-blue-800 p-8 md:p-10 rounded-2xl shadow-2xl text-left relative overflow-hidden" data-id="element-222">
          <div className="absolute -top-6 -left-4 text-9xl text-blue-900/30 font-serif leading-none select-none" data-id="element-223">
            "
          </div>

          <p className="text-xl md:text-2xl leading-relaxed relative z-10 font-medium text-blue-50" data-id="element-224">
            Within one week of going through the Patriot Bundle, you will have
            the vocabulary to win arguments, the historical context to
            understand the current crisis, and a renewed sense of pride that
            replaces the anxiety of the news cycle.
          </p>
        </div>
      </div>
    </section>;
}